import { useVisibilityConditionsSearch } from 'domains/banners/api/searchVisibilityConditions.hooks'

export const useVisibilityConditionsList = ({ placementId }) => {
  const {
    visibilityConditions,
    searchVisibilityConditionsByPlacementId,
    apiResult,
    apiSuccess,
    apiLoading,
    apiError,
  } = useVisibilityConditionsSearch({ placementId })

  return {
    apiResult,
    apiSuccess,
    apiLoading,
    apiError,
    visibilityConditions,
    searchVisibilityConditionsByPlacementId,
  }
}
